// extracted by mini-css-extract-plugin
module.exports = {"root":"SwitchSettingsForAllDays_root__-lLYT"};